import React from 'react';
import { motion } from 'framer-motion';

export const LoadingSpinner: React.FC = () => (
    <motion.div
        animate={{ rotate: 360 }}
        transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
        className="spinner"
    />
);